export default function authHeader() {
  const raw = localStorage.getItem("authUser");
  if (!raw || raw === "null" || raw === "undefined") return null;
  const obj = JSON.parse(raw);
  if (obj && obj.accessToken) {
    return "Bearer " + obj.accessToken;
  }
  return null;
}
